<template>
  <div class="d-flex align-center py-2 set-editable-row">
    <div class="flex-grow-1">
      {{ label }}
    </div>

    <v-text-field
      :value="durationMin"
      type="number"
      hide-details
      dense
      outlined
      style="max-width: 80px;"
      @input="onDurationInput"
    />
    <span class="mx-1">分</span>

    <v-text-field
      :value="price"
      type="number"
      hide-details
      dense
      outlined
      style="max-width: 100px;"
      @input="onPriceInput"
    />
    <span class="mx-1">円</span>

    <v-btn-toggle
      :value="taxCharge"
      mandatory
      dense
      class="ml-3 tax-charge-toggle"
      @change="$emit('update:taxCharge', $event)"
    >
      <v-btn
        small
        value="normal"
      >
        通常
      </v-btn>
      <v-btn
        small
        value="cut"
      >
        カット
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'SetEditableRow',
  props: {
    label: { type: String, required: true },
    durationMin: { type: Number, default: 0 },
    price: { type: Number, default: 0 },
    taxCharge: { type: String, default: 'normal' }, // 'normal' | 'cut'
  },
  emits: ['update:durationMin', 'update:price', 'update:taxCharge'],
  setup(_, { emit }) {
    const onDurationInput = v => {
      emit('update:durationMin', Number(v) || 0)
    }
    const onPriceInput = v => {
      emit('update:price', Number(v) || 0)
    }

    return { onDurationInput, onPriceInput }
  },
}
</script>
